import plurals from "plurals-cldr";

export const formatLocaleString = (
  localeString: string,
  data: { [key: string]: string | number } = {}
) => {
  let targetString = "";

  try {
    let parsed = JSON.parse(localeString);

    if ("count" in data) {
      const cardinalFormName = plurals(window.Shopify.locale, data.count);

      if (cardinalFormName in parsed) {
        targetString = parsed[cardinalFormName];
      }
    }
  } catch (error) {
    targetString = localeString;
  }

  return Object.entries(data)
    .reduce(
      (string, [key, value]) =>
        string.replace(
          new RegExp(`{{\\s{0,}${key.trim()}\\s{0,}}}`, "g"),
          String(value)
        ),
      targetString
    )
    .replace(/{{.*?}}/g, "");
};
